import { useApi } from "#hooks/useApi"
import STATUS from "#vacation/constants"
import { vacationIdGet } from "#vacation/services/api"
import { Person, Schedule } from "@mui/icons-material"
import {
	Box,
	CardContent,
	CardHeader,
	Chip,
	Grid,
	Stack,
	Typography,
} from "@mui/material"
import { useMemo } from "react"
import VacationHistoryDialog from "./VacationHistoryDialog"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import ErrorResponse from "#core/pages/ErrorResponse"
export default function VacationDetails({ id }) {
	const params = useMemo(() => ({ id }), [id])
	const {
		data: solicitud,
		loading,
		error,
	} = useApi(vacationIdGet, { autoFetch: !!id, params })
	const {
		date_start = "",
		date_end = "",
		created_at = "",
		days = 0,
		colaborador_name = "",
		status = "",
		authorized_by_name = "",
		authorize_name = "",
		authorize = null,
		authorized_by = null,
		date_approval = null,
		status_name = "",
	} = solicitud || {}
	const showAuthorized = authorized_by && authorize !== authorized_by

	const getStatusColor = (status) => {
		switch (status) {
			case STATUS.SOLICITADA:
				return "warning"
			case STATUS.APPROVE:
				return "success"
			case STATUS.RECHAZADA:
				return "error"
			case STATUS.CANCELADAS:
				return "error"
			default:
				return "default"
		}
	}

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse error={error?.response?.data?.message} />

	return (
		<Box>
			<CardHeader
				title={
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								gap: 1,
							}}
						>
							<Person color="primary" />
							<Typography variant="h6">{colaborador_name}</Typography>
						</Box>

						<Chip
							icon={<Schedule />}
							label={status_name}
							color={getStatusColor(status)}
							variant="outlined"
						/>
					</Box>
				}
				subheader={<VacationHistoryDialog id={solicitud.id} />}
			/>
			<CardContent>
				<Grid container spacing={5}>
					<Grid item xs={12} md={6}>
						<Stack spacing={1}>
							<Box sx={{ mb: 3 }}>
								<Typography variant="subtitle2" color="text.secondary" gutterBottom>
									Días Solicitados
								</Typography>
								<Typography variant="h4" color="primary" fontWeight="bold">
									{days} días
								</Typography>
							</Box>
							<Box>
								<Typography variant="subtitle2" color="text.secondary" gutterBottom>
									Fecha de Solicitud
								</Typography>
								<Typography variant="body1" fontWeight="medium">
									{created_at}
								</Typography>
							</Box>
							<Box>
								<Typography variant="subtitle2" color="text.secondary" gutterBottom>
									Solicitado a
								</Typography>
								<Typography variant="body1" fontWeight="medium">
									{authorize_name}
								</Typography>
							</Box>
							{showAuthorized && (
								<Box>
									<Typography variant="subtitle2" color="text.secondary" gutterBottom>
										Autorizada por
									</Typography>
									<Typography variant="body1" fontWeight="medium">
										{authorized_by_name}
									</Typography>
								</Box>
							)}
						</Stack>
					</Grid>

					<Grid item xs={12} md={6}>
						<div>
							<Stack spacing={2}>
								<Box sx={{ mb: 3 }}>
									<Typography variant="subtitle2" color="text.secondary" gutterBottom>
										Período de Vacaciones
									</Typography>
									<Box
										sx={{
											display: "flex",
											alignItems: "center",
											gap: 1,
											mt: 1,
										}}
									>
										<Chip label={date_start} variant="outlined" size="small" />
										<Typography color="text.secondary">hasta</Typography>
										<Chip label={date_end} variant="outlined" size="small" />
									</Box>
								</Box>
								{date_approval && (
									<Box>
										<Typography variant="subtitle2" color="text.secondary" gutterBottom>
											Fecha de autorización
										</Typography>
										<Typography variant="body1" fontWeight="medium">
											{date_approval}
										</Typography>
									</Box>
								)}
							</Stack>
						</div>
					</Grid>
				</Grid>
			</CardContent>
		</Box>
	)
}
